import axios from "axios";

export const updateMondayFetItemReferee = async (
  mondayClientItemId: string | null,
  referee: string
): Promise<void> => {
  return await axios
    .post(`${process.env.NEXT_PUBLIC_API_URL}/integration/monday/referee`, {
      data: {
        mondayClientItemId,
        referee,
      },
    })
    .then((res) => res.data);
};
